import React, { useState, useEffect, useCallback } from "react";
import { CiMoneyBill } from "react-icons/ci";
import { BsBoxSeam } from "react-icons/bs";
import { MdOutlinePending } from "react-icons/md";
import { IoIosCheckmark, IoIosClose } from "react-icons/io";
import { Link } from "react-router-dom";
import axios from "axios";
import { BASE_URL, USER_URL } from "../../constant/api";
import ProductApprovalModel from "../../components/AdminModal/ProductApprovalModel";
import Loader from "../../components/Loader/Loader";

function AdminProducts() {
  const [productData, setProductData] = useState([]);
  const [totalRevenue, setTotalRevenue] = useState([]);
  const [totalProduct, setTotalProduct] = useState([]);
  const [filter, setFilter] = useState("All");
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem("token");
  const [productStatus, setProductStatus] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

    const openModal = useCallback((product,status) => {
      setSelectedProduct(product);
      setIsModalOpen(true);
      setProductStatus(status);
    }, []);
  
  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedProduct(null);
    setProductStatus("");
    fetchProducts(filter); // Refresh product list after closing the modal
    console.log(filter);
  }, [filter]);

  // Fetch products based on filter
  const fetchProducts = async (status) => {
    setIsLoading(true);
    try {
      const url =
        status === "All"
          ? `/products/admin/`
          : `/products/admin/?status=${status.toLowerCase()}`;
      const response = await USER_URL.get(url);
      console.log(response);
      setProductData(response.data.Data || []);
    } catch (error) {
      console.error(`Error fetching products for status: ${status}`, error);
    } finally {
      setIsLoading(false);
    }
  };

  // Reusable function to fetch data
  const fetchData = async (url, setter) => {
    try {
      const response = await USER_URL.get(url);
      setter(response.data.data || []);
    } catch (error) {
      console.error(`Error fetching data from ${url}:`, error);
    }
  };

  useEffect(() => {
    fetchProducts(filter);
    fetchData(`${BASE_URL}/orders/admin/revenues/`, setTotalRevenue);
    fetchData(`${BASE_URL}/products/admin/`, setTotalProduct);
  }, [filter]);

  const filters = [
    {
      key: "all",
      label: "All",
      value: "All",
      icon: <CiMoneyBill size={20} />,
    },
    {
      key: "approved",
      label: "Approved",
      value: "Approved",
      icon: <IoIosCheckmark size={20} />,
    },
    {
      key: "rejected",
      label: "Rejected",
      value: "Rejected",
      icon: <IoIosClose size={20} />,
    },
    {
      key: "pending",
      label: "Pending",
      value: "Pending",
      icon: <MdOutlinePending size={20} />,
    },
  ];

  return (
    <div className="w-full">
      {/* Filter options */}
      <h1 className="text-2xl font-medium text-green-600 ">Product Approval</h1>
      <div className="flex w-full items-center justify-around border-b bg-white p-2">
        {filters.map((f) => (
          <div
            key={f.key}
            onClick={() => setFilter(f.value)}
            className={`flex cursor-pointer items-center gap-1 ${filter === f.value ? "font-bold text-brand-button-green-bg" : ""
              }`}
          >
            {f.icon}
            {f.label}
          </div>
        ))}
      </div>

      {/* Main content */}
      <div className="overflow-x-auto mt-5">
        {isLoading ? (
          <Loader />
        ) : productData.length === 0 ? (
          <div className="text-center mt-10">
            <BsBoxSeam className="text-6xl text-gray-400 mx-auto mb-4" />
            <p className="text-lg text-gray-600">No Products Found</p>
          </div>
        ) : (
          <>
            {/* Table Header */}
            <div className="min-w-[800px] grid grid-cols-[1fr,2fr,1fr,2fr,1fr,1fr,1fr,1fr,1fr] text-sm md:text-base  font-medium text-brand-button-green-bg">
              <div className="text-center">Item No</div>
              <div className="text-center">Seller Name</div>
              <div className="text-center">Product Code</div>
              <div className="text-center">Name</div>
              <div className="text-center">Price</div>
              <div className="text-center">Status</div>
              <div className="text-center">Approve</div>
              <div className="text-center">Reject</div>
              <div className="text-center">View</div>
            </div>

            {/* Table Body */}
            {productData.map((product, index) => (
              <div
                key={index}
                className="grid text-[#2F2E41] min-w-[800px] text-sm md:text-base grid-cols-[1fr,2fr,1fr,2fr,1fr,1fr,1fr,1fr,1fr] items-center gap-2 py-2"
              >
                <div className="border rounded-xl p-2 text-center">
                  {index + 1}
                </div>
                <div className="line-clamp-1 rounded-xl border p-2 text-center">
                  {product.name}
                </div>
                <div className="border p-2 rounded-xl text-center">
                  {product.id}
                </div>
                <div className="border p-2 rounded-xl text-center">
                  {product.name}
                </div>
                <div className="border p-2 rounded-xl text-center">
                  {product.price}
                </div>
                <div className={`border p-2 rounded-xl text-center ${product.status === "Approved" ? "text-green-600" : product.status === "Pending" ? "text-yellow-600" : "text-red-600"}`} >
                  {product.status}
                </div>
                <div 
                className="border p-2 rounded-xl text-center hover:bg-brand-primary 
                text-brand-text-light hover:text-white transition
                 ease-in-out duration-400 cursor-pointer"
                  onClick={() => openModal(product,"Approved")}
                >
                  Approve
                </div>
                
                <div 
                className="border p-2 rounded-xl text-center hover:bg-red-500
                 text-brand-text-light hover:text-white transition ease-in-out 
                 duration-400 cursor-pointer"
                  onClick={() => openModal(product, "Rejected")}
                 >
                  Reject
                </div>
                <div className="border p-2 rounded-xl text-center hover:bg-brand-primary text-brand-text-light hover:text-white transition ease-in-out duration-400">
                  <Link to={`/admin/product-details/${product.id}`}>View</Link>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
      <ProductApprovalModel
        selectedProduct={selectedProduct}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        status={productStatus}
      />
    </div>
  );
}

export default AdminProducts;
